<template>
  <div class="cookie-agreement" v-if="visibility">
    <h6>Ta strona korzysta z ciasteczek aby świadczyć usługi na najwyższym poziomie. Dalsze korzystanie ze strony oznacza, że zgadzasz się na ich użycie.</h6>
    <button class="default small reverse" @click="agree()">Zgoda</button>
  </div>
</template>

<script>
export default {
  name: 'CookieAgreement',
  data(){
    return{
      visibility: 0,
    }
  },
  created(){
    if(typeof localStorage.cookieAgreement == 'undefined' || localStorage.cookieAgreement != 1){
      this.visibility = 1;
    }else{
      this.visibility = 0;
    }
  },
  methods:{
    agree(){
      if(typeof localStorage.cookieAgreement == 'undefined'){
        localStorage.setItem("cookieAgreement", 1);
      }else{
        localStorage.cookieAgreement = 1;
      }
      this.visibility = 0;
    }
  }
}
</script>
<style scoped lang="scss">
  div.cookie-agreement { display: flex; align-items: center; justify-content: space-between; width: 100%; min-height: 40px; position: fixed; bottom: 0; z-index: 5; 
  background: $orangeDark; }
  div.cookie-agreement h6 { margin: 0; margin: 10px; font-size: 16px; color: #fff; }
  div.cookie-agreement button { margin: 10px; }
  div.cookie-agreement button:hover { background: #fff; color: $orangeDark; }  
</style>

